/**
 * PageOB404.js
 * @author Jaiván Piña
 */

//Dependencies
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux'
import $ from 'jquery';
import { withStyles } from '@material-ui/core/styles';

//material-ui
import Grid from '@material-ui/core/Grid';
import PlazoFijoBoton from '../common/components/PlazoFijoBoton';
import Legales from './Legales';

//Assets
import error from '../../../static/img/404_170x108.png';
import logoBh from '../../../static/img/logo-bh.png';
import {makeRelativeRedirect,makeAbsoluteRedirect} from "../Utils/RedirectUtils"

class ErrorIniciar extends Component {

    constructor(props) {
        super(props);
        this.state = {
            style: {
                marginTop: '',
                marginBottom: ''
            },
            disabledBtn: false,
        }
    }

    componentDidMount() {
        $(".load").fadeOut(700);
    }

    makeRedirect(url){
        return () => {
            window.location.replace("https://www.hipotecario.com.ar/personas/sucursales-y-cajeros/")
        }
    }
    
    render() {
        const {classes} = this.props;

        return (
            <div className={classes.mainContainer}>
                
                <Grid container
                    direction="row"
                    justify="flex-start"
                    alignItems="flex-start">
                        <img src={logoBh} className={classes.logoBh}/>
                </Grid>

                <Grid container
                    direction="row"
                    justify="center"
                    alignItems="center"
                    className={classes.containerData}>

                    <Grid item xs={12} sm={12}>
                        <img src={error} className="error-iniciar"  />
                    </Grid>
                    
                    <Grid item xs={12} container direction="column" justify="center" alignItems="center">
                        <h5 className={classes.notFound} >No podemos procesar tu solicitud</h5>
                        <h6 className={classes.description}>Por favor, acercate a una sucursal para finalizar el proceso. </h6>
                    </Grid>

                    <Grid item>
                        <PlazoFijoBoton text="ver sucursales" doAction={ makeAbsoluteRedirect("https://www.hipotecario.com.ar/personas/sucursales-y-cajeros/") }/>
                    </Grid>
                    
                </Grid>
            </div>
        );
    }
}

const styles = theme => ({
    mainContainer : {
        marginTop: "10px",
        textAlign: "center"
    },
    logoBh: {
        float: "left",
        marginTop: "27px",
        marginLeft: "27px",
    },
    containerData:{
        marginTop : "55px"
    },
    notFound: {
        width: "258px",
        height: "60px",
        fontFamily: "Roboto",
        fontSize: "26px",
        fontWeight: "bold",
        fontStyle: "normal",
        fontStretch: "normal",
        lineHeight: "normal",
        letterSpacing: "normal",
        color:"#606162",
        textAlign:"center",
        marginBottom: 19
    },
    description: {
        width: "300px",
        height: "85px",
        fontFamily: "Roboto",
        fontSize: "20px",
        fontWeight: "normal",
        fontStyle: "normal",
        fontStretch: "normal",
        lineHeight: 1.2,
        letterSpacing: "normal",
        textAlign: "center",
        color: "#929292",
        marginTop: 0,
        marginBottom: 10
    },
    //DESKTOP
    '@media  screen and (min-width: 787px)': {
        logoBh: {
            float: "left",
            marginTop: "42px",
            marginLeft: "263px"    
        },
        notFound: {
            width: "394px",
            height: "30px",
            marginBottom: 9
        },
        description:{
            width: "382px"
        }
    },
});

export default withStyles(styles)(ErrorIniciar);


// WEBPACK FOOTER //
// ./src/components/PlazoFijo/error/ErrorIniciar.js